export default {"src":"/_next/static/media/chz.f59293dd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};